<!-- Desktop design - Go Back button -->
@if (!isMobile && goBack()) {
  <div class="d-flex align-items-center desktop-goback"
    [ngStyle]="{ position: goBackPositionFixed() ? 'fixed' : 'absolute' }">
    <lib-button (callback)="pageNavigation('goBack')" id="goback" [disabled]="false" [buttonType]="'borderless'"
    [buttonSize]="buttonSize()" [buttonText]="'Go back'" [libIcon]="'back'" [iconLeft]="true"></lib-button>
  </div>
}

<!-- Desktop design -->
@if (!isMobile) {
  <div class="d-flex flex-row psic-gap-7"
    [ngClass]="{ 'justify-content-center': buttonCenterAlignment() }">
    <!-- Continue button placed on right of projected content -->
    @if (continue() && !paymentscreen()) {
      <lib-button [buttonSize]="buttonSize()"
      [buttonText]="continueButtonText()" [disabled]="!showButton()" (callback)="pageNavigation('continue')"></lib-button>
    }
  </div>
}

<!-- Mobile design -->
@if (isMobile) {
  <div class="d-flex flex-row justify-content-between align-items-center footer"
    [ngClass]="{ 'payment-screen': paymentscreen() }">
    @if (goBack()) {
      <lib-button (callback)="pageNavigation('goBack')" id="goback" [disabled]="false" [buttonType]="'borderless'"
      [buttonSize]="buttonSize()" [buttonText]="'Go back'" [libIcon]="'back'" [iconLeft]="true"></lib-button>
    }
    <lib-button [buttonSize]="buttonSize()" [buttonText]="continueButtonText()" [disabled]="!showButton()"
    (callback)="pageNavigation('continue')"></lib-button>
  </div>
}

<!-- Mobile version -->
@if (isMobile && paymentscreen()) {
  <div class="policy-details">
    <div class="policy-details__details">
      <div class="payment-bar" (click)="togglePolicyDetails()"></div>
      <div class="d-flex flex-row justify-content-between policy-details__info">
        <div class="d-flex flex-column psic-gap-2 policy-details__account">
          <p>Policy no.: {{policyData?.policyNumber}}</p>
          <p class="disclaimer">Term: {{currentPolicyTerm}}</p>
        </div>
        <div class="d-flex flex-column align-items-end psic-gap-1 policy-details__account">
          <p class="microtext-bold">Due today</p>
          <h5> {{getTotalAmountDue()}} </h5>
          <!-- TODO Commented this, once service gives value needs to display -->
          <!-- <p class="disclaimer">{{policyData?.premiumAmount ?? '-'}} per year</p> -->
        </div>
      </div>
    </div>
    @if ((viewPolicyInfo)) {
      <div class="d-flex flex-column psic-gap-6 policy-info">
        <ng-container *ngTemplateOutlet="policyInfoTemplate"></ng-container>
      </div>
    }
  </div>
}

<!-- Desktop version -->
@if (!isMobile && paymentscreen()) {
  <div class="d-flex flex-column psic-gap-6 payment-info hideSrollbar">
    <ng-container *ngTemplateOutlet="policyInfoTemplate"></ng-container>
    <lib-button [disabled]="!showButton()" [buttonText]="continueButtonText()" [buttonSize]="buttonSize()" (callback)="pageNavigation('continue')"></lib-button>
  </div>
}

<!-- Common policy info template -->
<ng-template #policyInfoTemplate>
  <div class="d-flex flex-column">
    <p class="alt-bold">{{policyData?.policyNumber}}</p>
    <p class="caption-bold">{{policyData?.lob ?? '' | productName}}</p>
    <p class="caption">{{address}}</p>
  </div>
  <span class="divider"></span>
  <div class="d-flex flex-column">
    <p class="disclaimer-bold">Current policy term</p>
    <p class="disclaimer">{{ currentPolicyTerm }}</p>
  </div>
  <span class="divider"></span>
  @if (!formData().value?.paymentAmountType) {
    <p class="caption">Select the amount(s) you want to pay and the payment method.</p>
  }
  @if (formData().value?.paymentAmountType) {
    <!-- TODO Commented this, once service gives value needs to display -->
    <div class="d-flex flex-row justify-content-between">
      <p class="disclaimer">Current annual premium</p>
      <p class="disclaimer-bold">{{policyData?.policyAnnualPremium | currency: 'USD':'symbol':'1.2-2'}}</p>
    </div>
    <span class="divider"></span>
    <div class="d-flex flex-row justify-content-between">
      <p class="disclaimer">{{formData().value?.paymentAmountType}}</p>
      <p class="disclaimer-bold">{{formData().value?.selectedAmtToPay}}</p>
    </div>
    <span class="divider"></span>
    @if (processingFeeResponse()?.eligible && showProcessingFee()) {
      <div class="d-flex flex-row justify-content-between">
        <p class="disclaimer">Premium Due Today</p>
        <p class="disclaimer-bold">{{formData().value?.selectedAmtToPay}}</p>
      </div>
      <div class="d-flex flex-row justify-content-between">
        <p class="disclaimer">Processing Fee*</p>
        <p class="disclaimer-bold">{{processingFeeResponse()?.convenienceFee | currency: 'USD':'symbol':'1.2-2'}}</p>
      </div>
    }
    <div class="d-flex flex-row justify-content-between">
      <p class="p-alt-bold account-details">Total due today</p>
      <h6>{{getTotalAmountDue()}}</h6>
    </div>
    <p class="disclaimer payment-login">To see your payment schedule please
      <span>
        <lib-button [disabled]="false" [buttonText]="'Login'" [buttonType]="'borderless'"
        (click)="redirectToLogin()"></lib-button>
      </span>
    </p>
  }
  <span class="divider"></span>
</ng-template>